import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = ["index", "href"]
const _hoisted_2 = ["index", "href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "menu-collapse" }
const _hoisted_6 = { class: "flex header" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "function-buttons" }
const _hoisted_9 = { class: "currency-section" }
const _hoisted_10 = { class: "currency_unit" }
const _hoisted_11 = { class: "title-avatar" }
const _hoisted_12 = { class: "main-container" }
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = { class: "table-number" }
const _hoisted_16 = {
  key: 0,
  class: "ticket-flex-container"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "dialog-footer" }

import { ref, computed, onMounted, nextTick, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  ElContainer,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElButton,
  ElScrollbar,
  ElHeader,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElMain,
  ElDialog,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElRadioGroup,
  ElRadioButton,
  ElNotification,
  ElTable,
  ElTableColumn,
  ElMessage,
} from "element-plus";
import axios, { ResponseType } from "@/utils/request";
import SvgIcon from "@/components/SvgIcon.vue";
import {
  enumeration_currencyTypeName,
  enumeration_currencyType,
  enumeration_order_type,
} from "@/utils/enumerations";
import usePiniaStore from "@/store/index";
import {
  Http_postUserSwitchCurrency,
  Http_getOrderAbnormal,
  Http_postOrderAbnormalCancel,
} from "@/http/apiFunction";
import type { AbnormalOrderInfo } from "@/http/response.type";
import { usePermissions } from "@/hooks/usePermissions";
import dayjs from "dayjs";
import PosManager from "@/components/PosManager.vue";

interface messageType {
  id: number;
  title: string;
  content: string;
  readStatus: number; //读状态：1-已读，0-未读
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const { cityListStore, userStore, paymentStore, fyPosStore } = usePiniaStore();
const router = useRouter();
const route = useRoute();
const isCollapse = ref(false);
const dialogVisible = ref(false);
const dialogSwitchCurrencyVisible = ref(false);
const chooseCurrencyType = ref(1);

const userInfo = computed(() => userStore.personInfo);
const selectMenus = computed(() => userStore.selectMenus);
const menuList: any = computed(() => userStore.menus);
const breadcrumbList = computed(() => userStore.breadcrumbList);
const includeComponent = computed(() => userStore.includeComponent);
const msgIdList: any = ref([]);
// 今日营收-权限
const yushen_settlement_dayreve_btn = usePermissions(
  "yushen_settlement_dayreve_btn"
);

const dialogTableVisible = ref(false);
const diffTableData = ref<AbnormalOrderInfo[]>([
  {
    orderId: 0,
    orderNo: "12312312",
    ticketNoLists: [""],
    amount: 0,
    currencyType: 0,
    abnormalType: 0, // 1未支付，2未打印
    abnormalDesc: "",
    createTime: "",
    type: 0,
    status: 0,
    createBy: "",
    printed: 0,
  },
]);
const frechLoading = ref(false);
const openLoading = ref(false);
// 保存BroadcastChannel实例的引用，用于清理
let broadcastChannel = ref<BroadcastChannel | null>(null);

onMounted(() => {
  const defaultV = route.meta.from as string;
  userStore.updateSelectMenus(defaultV); // 手动刷新页面，更新菜单命中
  userStore.getMyRole(); // 获取用户的权限和初始化菜单栏
  userStore.getPersonInfo(); // 更新用户信息
  cityListStore.getCityList(); // 更新城市信息

  // 初始化支付方式数据，只在应用启动时获取一次
  paymentStore.getPaymentOptions(true);
  // 初始化会话ID，确保缓存验证机制正常工作
  paymentStore.initializeSession();

  queryInnerMessage();

  // 使用 nextTick 确保组件完全挂载后再设置监听器
  nextTick(() => {
    // 增加额外延迟，确保所有同步代码执行完毕
    setupBroadcastListener();
  });
});

onUnmounted(() => {
  // 组件销毁时清理BroadcastChannel
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }
});

/**
 * 设置 BroadcastChannel 监听器
 * 使用延迟处理机制确保消息有序性，避免与页面初始化产生竞态条件
 */
const setupBroadcastListener = () => {
  const senderTabId = sessionStorage.getItem("senderTabId");
  console.log("🚀 结束:", senderTabId);

  // 如果已存在channel实例，先清理
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }

  broadcastChannel.value = new BroadcastChannel("reload_control");
  broadcastChannel.value.addEventListener("message", (event) => {
    if (event.data.type === "RELOAD_OTHER_TABS") {
      // 如果不是发送者，则处理reload指令
      if (event.data.senderTabId !== senderTabId) {
        // 是否关闭确认离开提示
        sessionStorage.setItem("window_leave_confirm_closed", "true");
        location.reload();
      }
    }
  });
};

const queryInnerMessage = async () => {
  const res: ResponseType = await axios.get("/facade/sale/sitemsg/user/page");
  if (res.code === 0) {
    let message = "";
    res.data?.list.forEach((item: messageType) => {
      if (item.readStatus === 0 && msgIdList.value.length < 10) {
        message += `<p>${item.title}</p>`;
        msgIdList.value.push(item.id);
      }
    });
    if (msgIdList.value.length > 0) {
      ElNotification({
        title: "未读站内通知",
        message: message,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 0,
        onClose: closeNotices,
        onClick: goToPersonCenter,
      });
    }
  }
};

// 关闭站内通知弹窗-标记站内通知为已读
const closeNotices = async () => {
  const res: ResponseType = await axios.post("/facade/sale/sitemsg/user/read", {
    idList: msgIdList.value,
  });
  if (res.code === 0) {
    console.log("站内通知已读");
  }
};

const goToPersonCenter = () => {
  router.push("/home/person-center");
};

const handleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};

const handleselect = (key: string, keyPath: string[]) => {
  if (key === "/") return;

  const path = keyPath.join("/");
  // 打开查询+表单页面的刷新
  cityListStore.updateNeedReflash(true);
  // 点击同一个菜单
  if (router.currentRoute.value.path === path) {
    cityListStore.updateReflashNum();
  } else {
    router.push(path);
  }
};

const handleGo = (val: string) => {
  if (val === "a") {
    router.push("/home/person-center");
  } else {
    dialogVisible.value = true;
  }
};

// const newtab = (e, v) => {
//   console.log("gaoxiao ", e);
//   console.log("xixihaha ", v);
//   const { path } = v;
//   e.target.innerHTML = `<a href=${path}>${v.meta.title}</a>`;
// };

const confirmSwitchCurrency = async () => {
  const res = await Http_postUserSwitchCurrency(chooseCurrencyType.value);
  if (res.code === 0) {
    localStorage.setItem("token_value", res.data.token);
    window.location.reload();
  }
};
const handleSwitchCurrency = async (val: number) => {
  if (
    userInfo.value.currencyTypeList &&
    userInfo.value.currencyTypeList.length === 1
  ) {
    return;
  }
  chooseCurrencyType.value = val;
  dialogSwitchCurrencyVisible.value = true;
};
const confirm = async () => {
  const res: ResponseType = await axios.post("/facade/sale/login/out");
  if (res.code === 0) {
    router.replace(`/login`); // 主动退出
    sessionStorage.setItem("redirectUrl", ""); // 主动退出不记历史地址。
    localStorage.setItem("token_value", "");
    userStore.updateBreadcrumbList([]); // 主动退出清空面包屑
  }
};

const addYushen = () => {
  router.push({
    path: "/settlement-management/add-yushen",
  });
};

const handleJumpQuery = (row: AbnormalOrderInfo) => {
  // 跳转订单详情
  console.log("打印", row);
  let url = "";

  if (row.type > 100) {
    // 旅游产品
    url = "/tour-product/API-product-order-detail";
  } else if (row.type === 12 || row.type === 25) {
    // 包车票
    url = "/order-tickets-management/ticket-charter-detail";
  } else {
    // 其他为车票
    url = "/order-tickets-management/order-list-store-detail";
  }
  dialogTableVisible.value = false;

  router.push({
    path: url,
    query: {
      id: row.orderId,
    },
  });
};

const handleCancelOrder = async (row: any) => {
  frechLoading.value = true;
  const parmas = {
    orderId: row.orderId,
  };
  const res = await Http_postOrderAbnormalCancel(parmas);
  frechLoading.value = false;

  if (res.code === 0) {
    ElMessage.success("取消成功");
  }
  handlereFreshTable();
};

const openDialogTable = async () => {
  // 包车票订单不显示
  openLoading.value = true;
  const res = await Http_getOrderAbnormal();
  openLoading.value = false;

  if (res.code === 0) {
    diffTableData.value = res.data;
    dialogTableVisible.value = true;
  }
};

const handlereFreshTable = async () => {
  // 刷新表格
  frechLoading.value = true;
  const res = await Http_getOrderAbnormal();
  frechLoading.value = false;

  if (res.code === 0) {
    diffTableData.value = res.data;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElContainer), { class: "content-layout" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElMenu), {
          class: "menu-list",
          "default-active": selectMenus.value,
          "unique-opened": true,
          collapse: isCollapse.value,
          onSelect: handleselect
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElScrollbar), { class: "menu-scrollbar" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElMenuItem), {
                  index: "/home/person-center",
                  class: "menu_max_width"
                }, {
                  title: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "logo" }, [
                      _createElementVNode("img", {
                        class: "logo_title",
                        src: _imports_0
                      }),
                      _createElementVNode("p", null, "冠忠巴士集團成員")
                    ], -1)
                  ]))]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(ElSubMenu), {
                    key: item.path,
                    index: item.path,
                    class: _normalizeClass({
              hideIcon: isCollapse.value,
              isLine: isCollapse.value && _unref(route).path.includes(item.path),
            })
                  }, {
                    title: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: item.meta.icon,
                        size: 16,
                        color: "#fff"
                      }, null, 8, ["name"]),
                      _withDirectives(_createElementVNode("span", { style: {"margin-left":"4px"} }, _toDisplayString(item.meta.title), 513), [
                        [_vShow, !isCollapse.value]
                      ])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children.filter((a) => !a.meta.hidden), (v, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: v.path + i
                        }, [
                          (v.children?.length > 0)
                            ? (_openBlock(), _createBlock(_unref(ElSubMenu), {
                                key: 0,
                                index: v.path
                              }, {
                                title: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v.meta.title), 1)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.children.filter((a) => !a.meta.hidden), (vv) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: vv.path
                                    }, [
                                      (vv.meta.target === '_blank')
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            index: vv.path,
                                            href: '/' + vv.path
                                          }, [
                                            (_openBlock(), _createBlock(_unref(ElMenuItem), {
                                              key: vv.path
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(vv.meta.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          ], 8, _hoisted_1))
                                        : (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                                            onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                            index: vv.path,
                                            href: item.path + '/' + v.path + '/' + vv.path
                                          }, [
                                            (_openBlock(), _createBlock(_unref(ElMenuItem), {
                                              index: vv.path,
                                              key: vv.path
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(vv.meta.title), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                          ], 40, _hoisted_2))
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                            : (v.meta.target === '_blank')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: '/' + v.path,
                                  target: "_blank"
                                }, [
                                  _createVNode(_unref(ElMenuItem), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(v.meta.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 8, _hoisted_3))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  href: item.path + '/' + v.path,
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                                  onDragstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                                }, [
                                  _createVNode(_unref(ElMenuItem), {
                                    index: v.path
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(v.meta.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"])
                                ], 40, _hoisted_4))
                        ], 64))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index", "class"]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ElButton), {
                onClick: handleCollapse,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(SvgIcon, {
                    name: "expand",
                    size: 24,
                    color: "#fff"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["default-active", "collapse"]),
        _createVNode(_unref(ElContainer), { class: "layout-container" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElHeader), { class: "layout-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(ElBreadcrumb), { separator: "/" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElBreadcrumbItem), null, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("首页", -1)
                        ]))]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(ElBreadcrumbItem), {
                          key: item.path
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: _normalizeClass({ isActive: index === breadcrumbList.value.length - 1 })
                            }, _toDisplayString(item.title), 3)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(PosManager),
                      _createVNode(_unref(ElButton), {
                        class: "complex_btn",
                        onClick: openDialogTable,
                        loading: openLoading.value
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode(" 异常单 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading"]),
                      _withDirectives(_createVNode(_unref(ElButton), {
                        class: "yushen_btn",
                        onClick: addYushen
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" 今日营收 ", -1)
                        ]))]),
                        _: 1
                      }, 512), [
                        [_vShow, _unref(yushen_settlement_dayreve_btn)]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(ElRadioGroup), {
                        modelValue: userInfo.value.currencyType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userInfo.value.currencyType) = $event)),
                        class: "currency-items"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userInfo.value.currencyTypeList, (currencyItem) => {
                            return (_openBlock(), _createBlock(_unref(ElRadioButton), {
                              key: currencyItem,
                              value: currencyItem,
                              onClick: _withModifiers(($event: any) => (handleSwitchCurrency(currencyItem)), ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(enumeration_currencyTypeName)[currencyItem]), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(userInfo.value.unitName), 1),
                    _createVNode(_unref(ElDropdown), {
                      placement: "bottom-end",
                      onCommand: handleGo
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_unref(ElDropdownMenu), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElDropdownItem), {
                              command: "a",
                              class: "person_dropdown_item"
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" 个人中心 ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDropdownItem), {
                              command: "b",
                              class: "person_dropdown_item"
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" 退出登录 ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), { class: "flex person" }, {
                          default: _withCtx(() => [
                            _createVNode(SvgIcon, {
                              name: "avatar",
                              size: 24
                            }),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(userInfo.value.name), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElMain), { class: "layout-main" }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_12, [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      Component
                        ? (_openBlock(), _createBlock(_KeepAlive, {
                            key: 0,
                            include: includeComponent.value
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                              key: _ctx.$route.path
                            }))
                          ], 1032, ["include"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: "退出确认",
      width: "30%",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_13, [
          _createVNode(_unref(ElButton), {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "tips-m" }, "退出后需重新登录，请确认是否退出当前登录", -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogSwitchCurrencyVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogSwitchCurrencyVisible).value = $event)),
      title: "确认切换币种",
      width: "30%",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_unref(ElButton), {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (dialogSwitchCurrencyVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: confirmSwitchCurrency
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode(" 确定 ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "tips-m" }, "切换币种将刷新页面、清除购物车车票。", -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogTableVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogTableVisible).value = $event)),
      title: "异常单",
      width: "80%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_18, [
          _createVNode(_unref(ElButton), {
            type: "success",
            onClick: handlereFreshTable
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode(" 刷新 ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "danger",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (dialogTableVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" 关闭 ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createBlock(_unref(ElTable), {
            data: diffTableData.value,
            border: "",
            style: {"width":"100%"},
            class: "diffTableClass",
            "scrollbar-always-on": "",
            height: "600",
            "highlight-current-row": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), {
                type: "index",
                width: "40"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(scope.$index + 1), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "orderNo",
                label: "订单号",
                width: "200"
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "ticketNos",
                label: "车票号",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.ticketNos && scope.row.ticketNos.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(scope.row.ticketNos.join("、")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "orderTypeName",
                label: "订单类型",
                width: "120"
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "payTypeName",
                label: "支付方式",
                width: "100"
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "amount",
                label: "金额",
                width: "110"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(enumeration_currencyType)[scope.row.currencyType]) + " " + _toDisplayString(scope.row.amount), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "abnormalDesc",
                label: "异常情况",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                'unpaid-text': scope.row.abnormalType === 1,
                'unprinted-row': scope.row.abnormalType === 2,
              })
                  }, _toDisplayString(scope.row.abnormalDesc), 3)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                prop: "createTime",
                label: "下单时间",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.createTime
                ? _unref(dayjs)(scope.row.createTime).format("HH:mm:ss")
                : ""), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                label: "操作",
                width: "110"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(ElButton), {
                    text: "",
                    class: "select_btn",
                    type: "primary",
                    onClick: _withModifiers(($event: any) => (handleJumpQuery(scope.row)), ["prevent"])
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode(" 详情 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _withDirectives(_createVNode(_unref(ElButton), {
                    text: "",
                    class: "select_btn",
                    type: "danger",
                    onClick: _withModifiers(($event: any) => (handleCancelOrder(scope.row)), ["prevent"])
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode(" 取消 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, scope.row.abnormalType === 1]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, frechLoading.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})